
































import { Component, Prop, Vue } from "vue-property-decorator";
import Textfield from "@/components/Textfield.vue";
import Button from "@/components/Button.vue";
import Logo from "@/components/Logo.vue";

@Component({
  components: {
    appLogo: Logo,
    appTextfield: Textfield,
    appButton: Button
  }
})
export default class ResetPassword extends Vue {
  @Prop({ default: null }) readonly token?: string;
  newPassword = "";
  status = "changing";

  onSubmit(): void {
    this.axios
      .put(`/api/auth/reset-password/${this.token}`, {
        password: this.newPassword
      })
      .then(() => (this.status = "success"))
      .catch(() => (this.status = "error"));
  }
}
